import CustomerSelect from './CustomerSelect'

export default CustomerSelect
